import { INTERVIEW_SLICE } from "./slice";

export const CALCULATE_COMPATIBILITY_ACTION = `${INTERVIEW_SLICE}/calculateCompatibility` as const;